export const SET_PAYSLIP_DATA = 'SET_PAYSLIP_DATA'
